import React, { useState } from "react";
import Filters from "../components/SheetPayment/Filters";
import CustomersTable from "../components/SheetPayment/CustomersTable";
import { Button } from "../components/Elements"; 
import PageTitle from "../components/PageTitle";
import { pageTitleTexts } from "../../constants/texts/pageTitleTexts";
import { buttonTexts } from "../../constants/texts/buttonTexts";

export default function CreateSheetPayment() {
  const [filtersIsOpen, setFiltersIsOpen] = useState(true);

 


  return (
    <div className="w-full">
      <PageTitle title={pageTitleTexts.createSheetPayment} />

      <div className="px-4 py-2 flex flex-col justify-start space-y-2">
        <h1 className="font-bold text-contrast-90 text-2xl px-2">
          Toplu Ödeme Başlat
        </h1>

        <div className=" flex flex-row justify-end items-center px-2">
          <Button
            size="sm"
            hover="gray"
            color="gray"
            callback={() => setFiltersIsOpen(!filtersIsOpen)}

          >
            <span className="mr-3">{buttonTexts.filterOpen}</span>
            <img src="/icons/filter.svg" alt="filter" />
          </Button>
        </div>
      </div>


      <Filters isOpen={filtersIsOpen} setFiltersIsOpen={setFiltersIsOpen}   />
      <CustomersTable />
    </div>
  );
}
